<template>
<div>
  <v-flex xs10 offset-xs1 class='mb-5'>
    <div class='fl hf' style='align-items: flex-end;'>
      <div class='golden-left'>
        <h1 class='mb-4'>{{ 'report-of-sickness.overview' | translate }}</h1>
        <p>{{ 'report-of-sickness.form.index-description' | translate }}</p>
      </div>

      <div class='golden-right' style='padding-left: 66px;'>
        <!-- <Button style="float: right" primary @click="openNewReportOfSickness">{{ 'report-of-sickness.create-new' | translate }}</Button> -->

        <new-report-of-sickness-card-button style='float: right; max-width: 185px;' @click="openNewReportOfSickness" />
        <!-- <card-button positive
          first='Ik wil'
          main='meerdere verzuimen'
          second='importeren'
          @click="openImport"
        /> -->
      </div>
    </div>
  </v-flex>

  <div class='mb-5 filters-container'>
    <v-flex xs10 offset-xs1>
      <div class='hf aic fl'>
        <text-field :placeholder="$t('input.placeholders.which-report-of-sickness-are-you-looking-for')" class='mr-4' style='width: 33%' v-model="search">
          <v-icon slot="left">search</v-icon>
        </text-field>

        <date-picker clearable v-model="fromDate" style='width: 16%' class='mr-4' :min="minDate" :max="maxDate"/>
        <date-picker clearable v-model="untilDate" style='width: 16%' class='mr-4' :min="minDate" :max="maxDate" right/>

        <radio-group-item small positive
          :selected="showClosed"
          class="mr-4"
          :click="() => showClosed = !showClosed"
          style='position: relative; top: 2px; width: 16%'>
          Gesloten verzuim
        </radio-group-item>
        <radio-group-item small secondary
          :selected="showOpen"
          :click="() => showOpen = !showOpen"

          style='position: relative; top: 2px; width: 16%'>
          Lopend verzuim
        </radio-group-item>

      </div>
    </v-flex>
  </div>

  <v-flex xs10 offset-xs1>
      <div class="hf">
        <v-data-table
          :headers="headers"
          :items="reports"
          :loading="isReportsOfSicknessLoading"
          :search="search"
          :pagination.sync="pagination"
          :rows-per-page-items="[5, 10, 25, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }]"
          rows-per-page-text='Rijen per pagina'>

          <v-progress-linear slot="progress" color="#cdd2dc" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr @click="() => handleSelectReportOfSickness(props.item.reportOfSickness, props.item.employee)" style='cursor: pointer;'>
              <td>{{ props.item.employee.name }}</td>
              <td>{{ props.item.employee.employeeNumber }}</td>
              <td>{{ formatDate(props.item.reportOfSickness.firstOfAbsence) }}</td>
              <td />
              <td>
                <div class='fl aic hf'>
                  <report-of-sickness-disability-rate-graph
                    :reportOfSickness="props.item.reportOfSickness" :width="130" :height="26" class='mr-3' />
                  <span>{{ props.item.lastDisabilityRate }} %</span>
                </div>
              </td>
              <td>
                <div class='uwv-decision-indicator' v-if="props.item.hasUwvDecision">
                  <uwv-logo class='uwv-icon' />
                </div>
                <p v-else>Nee</p>
              </td>
              <td>{{ formatDate(props.item.lastPeriodReportDate) }}</td>
              <td>{{ props.item.reportOfSickness.recovery ? formatDate(props.item.reportOfSickness.recovery.recoveryDate) : null }}</td>
              <td align='right'>{{ 'report-of-sickness.states.' + props.item.reportOfSickness.superficialStatus | translate }}</td>
            </tr>
          </template>

          <div class="no-results-badge" slot="no-results">
            <v-icon>warning</v-icon>
            <p>{{ 'errors.no-results-found' | translate }}
              <span>{{ search }}</span>.
            </p>
          </div>

          <div class="no-results-badge" slot="no-data">
            <p>{{ 'errors.no-data-found' | translate }}</p>
          </div>
        </v-data-table>
      </div>
      <!-- <ReportsOfSicknessTimeline :reportsOfSickness="reportsOfSickness" :employees="employees" v-if="isTimeline" /> -->
  </v-flex>
</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Compositions from '@/views/helpers/compositions';
import Helpers from '@/shared/helpers/functions';

import TextField from '@aevitae/aevitaeui/0_atoms/input/TextField.vue';
import RadioGroupItem from '@aevitae/aevitaeui/0_atoms/input/RadioGroupItem.vue';

import ReportsOfSicknessView from '@/views/constants/reports-of-sickness';
import ReportsOfSicknessResource from '@/resources/constants/reports-of-sickness';
import NewReportOfSicknessCardButton from '@/views/components/generic/NewReportOfSicknessCardButton.vue';
import DatePicker from '@aevitae/aevitaeui/1_molecules/Input/DatePicker.vue';

/* import ReportsOfSicknessTimeline from '@/views/components/reports-of-sickness-timeline/ReportsOfSicknessTimeline.vue'; */
import ReportOfSicknessDisabilityRateGraph from '@/views/components/reports-of-sickness/ReportOfSicknessDisabilityRateGraph.vue';

import UwvLogo from '@aevitae/aevitaeui/0_atoms/icons/UwvLogo.vue';

export default {
  name: 'ReportsOfSicknessIndex',
  components: {
    TextField,
    RadioGroupItem,
    // ReportsOfSicknessTimeline,
    ReportOfSicknessDisabilityRateGraph,
    NewReportOfSicknessCardButton,
    UwvLogo,
    DatePicker
  },
  data () {
    return {
      headers: [
        { text: 'Naam', value: 'employee.lastName' },
        { text: 'Personeelsnr.', value: 'employee.employeeNumber' },
        { text: '1e Verzuimdag', value: 'reportOfSickness.firstOfAbsence' },
        { text: '', value: 'search', width: '0px' },
        { text: 'Arbeidsongeschiktheid', value: 'lastDisabilityRate' },
        { text: 'UWV', value: 'hasUwvDecision' },
        { text: 'Laatste wijziging', value: 'lastPeriodReportDate' },
        { text: 'Hersteld op', value: 'reportOfSickness.recovery.recoveryDate' },
        { text: 'Lopend / Gesloten', value: 'reportOfSickness.superficialStatus', align: 'right' }
      ]
    };
  },
  mounted () {
    this.$store.dispatch(ReportsOfSicknessResource.Actions.LoadAll.START,
      this.$store.getters.selectedEmployer.id);
  },
  computed: {
    ...mapGetters({
      reportsOfSickness: 'reportsOfSickness',
      isReportsOfSicknessLoading: 'isReportsOfSicknessLoading',
      filters: 'reportsOfSicknessIndexFilters',
      employees: 'employees'
    }),

    fromDate: {
      get () { return this.filters.fromDate; },
      set (v) { this.changeFilter('fromDate', v); }
    },
    untilDate: {
      get () { return this.filters.untilDate; },
      set (v) { this.changeFilter('untilDate', v); }
    },
    showClosed: {
      get () { return this.filters.showClosed; },
      set (v) { this.changeFilter('showClosed', v); }
    },
    showOpen: {
      get () { return this.filters.showOpen; },
      set (v) { this.changeFilter('showOpen', v); }
    },
    search: {
      get () { return this.filters.search; },
      set (v) { this.changeFilter('search', v); }
    },
    pagination: {
      get () { return this.filters.pagination; },
      set (v) { this.changeFilter('pagination', v); }
    },
    minDate () {
      return this.filters.minDate;
    },
    maxDate () {
      return this.filters.maxDate;
    },

    reports () {
      let result = [];
      for (let employeeId in this.reportsOfSickness) {
        let employee = this.$store.getters.employees.find(e => e.id.toString() === employeeId);
        if (employee == null) {

        } else {
          this.reportsOfSickness[employeeId].forEach(r => {
            if (new Date(r.firstOfAbsence) > new Date(this.minDate)) {
              if (this.fromDate == null || (this.fromDate != null && new Date(r.firstOfAbsence) >= new Date(this.fromDate))) {
                if (this.untilDate == null || (this.untilDate != null && new Date(r.firstOfAbsence) <= new Date(this.untilDate))) {
                  if ((this.showOpen && r.superficialStatus === 'Open') || (this.showClosed && r.superficialStatus === 'Closed')) {
                    result.push({
                      reportOfSickness: r,
                      employee: employee,
                      search: r.getSearchString() + (employee != null ? employee.getSearchString() : ''),
                      lastDisabilityRate: this.getLastDisabilityRate(r),
                      lastPeriodReportDate: this.getLatestReportDate(r),
                      hasUwvDecision: r.uwvDecisions.length > 0
                    });
                  }
                }
              }
            }
          });
        }
      }
      return result;
    }
  },
  methods: {
    formatDate: value => Helpers.Dates.formatDate(value),

    openNewReportOfSickness () {
      this.$store.dispatch(ReportsOfSicknessView.Actions.Tabs.OPEN_NEW);
    },

    openImport () {
      this.$store.dispatch(ReportsOfSicknessView.Actions.Tabs.OPEN_IMPORT_NEW);
    },

    handleSelectReportOfSickness (reportOfSickness, employee) {
      // passing the ReportOfSickness and Employee to the tab
      // will break reactivity. Should get them from stores in next
      // components.
      this.$store.dispatch(ReportsOfSicknessView.Actions.Tabs.OPEN_DETAILS, {
        reportOfSickness: reportOfSickness,
        employee: employee
      });
    },

    getLastDisabilityRate (reportOfSickness) {
      return Compositions.getLatestDisabilityRateFromReportOfSickness(reportOfSickness);
    },

    getLatestReportDate (reportOfSickness) {
      if (reportOfSickness.recovery != null) {
        return reportOfSickness.recovery.reportDate;
      } else if (reportOfSickness.periods.length > 0) {
        return reportOfSickness.periods[reportOfSickness.periods.length - 1].reportDate;
      } else return reportOfSickness.reportDate;
    },

    changeFilter (filter, value) {
      this.$store.dispatch(ReportsOfSicknessView.Actions.CHANGE_INDEX_FILTER, {
        filter: filter,
        value: value
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/variables.scss';

.filters-container {
  background-color: white;
  border-radius: $border-radius;
}

.uwv-decision-indicator {
  position: relative;
  height: 26px;
  width: 32px;
  border-radius: 5px;
  background-color: $uwv-primary;
  display: block;
  left: -3px;

  .uwv-icon {
    fill: white;
    top: 3px;
    left: -9px;
    position: absolute;
    z-index: 0;
    height: 109%;
  }
}
</style>
